export const SEASONS = {
  spring: {
    name: '春',
    reading: 'Haru',
    color: 'from-pink-500 to-rose-400',
    bgColor: 'from-pink-50 to-rose-50 dark:from-pink-900/10 dark:to-rose-900/10',
    ingredients: [
      {
        name: '桜鯛',
        reading: 'Sakura-dai',
        description: '春季產卵期的真鯛，魚身染上櫻花般的粉紅色。脂肪豐富，帶有優雅的甜味。'
      },
      {
        name: '鱚',
        reading: 'Kisu',
        description: '被稱為「海中的香魚」的春季白身魚。細緻清淡的風味是江戶前壽司的精華。'
      },
      {
        name: '蛍烏賊',
        reading: 'Hotaru-ika',
        description: '富山灣春季的代表性海產。濃郁的內臟鮮味與彈牙的口感令人難忘。'
      },
      {
        name: '初鰹',
        reading: 'Hatsu-gatsuo',
        description: '春季隨黑潮北上的鰹魚。清爽的赤身帶有迷人的鮮味。'
      }
    ]
  },
  summer: {
    name: '夏',
    reading: 'Natsu',
    color: 'from-blue-500 to-cyan-400',
    bgColor: 'from-blue-50 to-cyan-50 dark:from-blue-900/10 dark:to-cyan-900/10',
    ingredients: [
      {
        name: '雲丹',
        reading: 'Uni',
        description: '夏季盛產的赤海膽和馬糞海膽。濃郁的甜味與海洋的香氣在口中擴散開來。'
      },
      {
        name: '鯵',
        reading: 'Aji',
        description: '脂肪豐富的夏季竹莢魚。搭配生薑與蔥花，更能襯托出清爽的鮮味。'
      },
      {
        name: '穴子',
        reading: 'Anago',
        description: '梅雨季節的星鰻最為肥美，魚身豐滿且油脂達到最佳狀態。'
      },
      {
        name: '鮑',
        reading: 'Awabi',
        description: '夏季貝類之王。獨特的嚼勁與越嚼越鮮的滋味令人著迷。'
      }
    ]
  },
  autumn: {
    name: '秋',
    reading: 'Aki',
    color: 'from-orange-500 to-amber-400',
    bgColor: 'from-orange-50 to-amber-50 dark:from-orange-900/10 dark:to-amber-900/10',
    ingredients: [
      {
        name: '秋刀魚',
        reading: 'Sanma',
        description: '秋季美味的代表。油脂豐富的秋刀魚與回游鰹魚一同宣告秋天的到來。'
      },
      {
        name: '鯖',
        reading: 'Saba',
        description: '秋季的鯖魚美味到有「不給媳婦吃」的俗語。醋漬後更能凝聚其鮮味。'
      },
      {
        name: 'いくら',
        reading: 'Ikura',
        description: '從秋鮭取出的新鮮魚卵，細心剝離後浸泡在特製醬油中。'
      },
      {
        name: '戻り鰹',
        reading: 'Modori-gatsuo',
        description: '在北方海域飽食後南下的鰹魚。帶有如鮪魚腹肉般濃郁的油脂。'
      }
    ]
  },
  winter: {
    name: '冬',
    reading: 'Fuyu',
    color: 'from-indigo-500 to-violet-400',
    bgColor: 'from-indigo-50 to-violet-50 dark:from-indigo-900/10 dark:to-violet-900/10',
    ingredients: [
      {
        name: '鮪',
        reading: 'Maguro',
        description: '冬季大間產的本鮪魚堪稱極品。細緻的油脂與深邃的赤身達到完美平衡。'
      },
      {
        name: '鰤',
        reading: 'Buri',
        description: '被稱為「寒鰤」的冬季鰤魚。豐富的油脂帶有甜味，入口即化。'
      },
      {
        name: '白子',
        reading: 'Shirako',
        description: '真鱈的精巢。綿密濃郁的風味在寒冬中更顯突出。'
      },
      {
        name: '平目',
        reading: 'Hirame',
        description: '寒冬的比目魚肉質緊實，魚鰭邊緣的油脂也達到最佳狀態，是冬季的高級白身魚。'
      }
    ]
  }
};